(function () {
    'use strict';

    function refreshSupportContacts() {
        var contacts = document.querySelectorAll('[data-support-status]');
        var now = new Date();
        for (var index = 0; index < contacts.length; index++) {
            var contact = contacts[index];
            var parts;
            var schedule;
            try {
                schedule = JSON.parse(contact.getAttribute('data-support-schedule'));
                parts = new Intl.DateTimeFormat('en-GB', {
                    timeZone: contact.getAttribute('data-support-timezone'),
                    weekday: 'short',
                    hour: '2-digit',
                    minute: '2-digit',
                    hourCycle: 'h23'
                }).formatToParts(now);
            } catch (error) {
                continue;
            }
            var values = {};
            for (var partIndex = 0; partIndex < parts.length; partIndex++) {
                values[parts[partIndex].type] = parts[partIndex].value;
            }
            var weekdays = {Mon: '1', Tue: '2', Wed: '3', Thu: '4', Fri: '5', Sat: '6', Sun: '7'};
            var day = weekdays[values.weekday];
            var minute = Number(values.hour) * 60 + Number(values.minute);
            var hours = schedule && schedule[day];
            var online = !!hours
                && minute >= Number(hours.start_minutes)
                && minute < Number(hours.end_minutes);
            contact.classList.toggle('is-online', online);
            contact.classList.toggle('is-offline', !online);
            var label = contact.querySelector('[data-support-label]');
            var text = online
                ? contact.getAttribute('data-support-online') + hours.end
                : contact.getAttribute('data-support-offline');
            if (label && label.textContent !== text) {
                label.textContent = text;
            }
        }
    }

    function initializeSupportContacts() {
        if (!document.querySelector('[data-support-status]')) {
            return;
        }
        refreshSupportContacts();
        window.setInterval(refreshSupportContacts, 60000);
        document.addEventListener('visibilitychange', function () {
            if (!document.hidden) {
                refreshSupportContacts();
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeSupportContacts);
    } else {
        initializeSupportContacts();
    }
}());
